import { render, staticRenderFns } from "./_siteSubNavigation.vue?vue&type=template&id=0c981bd8"
import script from "./_siteSubNavigation.vue?vue&type=script&lang=js"
export * from "./_siteSubNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports